<template>
    <div class="breadcrumb">
        <ul>
            <li
            v-for="(breadcrumb, idx) in breadcrumbList"
            :key="idx"
            @click="routeTo(idx)"
            :class="{'linked': !!breadcrumb.link}">
                {{ breadcrumb.name }}
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: 'Breadcrumb',
    data () {
        return {
            breadcrumbList: []
        }
    },
    mounted () { 
        this.updateList() 
    },
    watch: { 
        '$route' () { 
            this.updateList() 
        } 
    },
    methods: {
        routeTo (pRouteTo) {
            if (this.breadcrumbList[pRouteTo].link) this.$router.push(this.breadcrumbList[pRouteTo].link)
        },
        updateList () { 
            this.breadcrumbList = this.$route.meta.breadcrumb 
        }
    }
}
</script>
<style   lang="scss">
    .breadcrumb {
        ul {
            display: flex;
            list-style: none;
            padding: 0;
            li {
                font-size: 12px;
                font-weight: 300;
                color: #a8a5a4;
                &.linked{
                    cursor: pointer;
                }
                &:last-child {
                    cursor: default;
                    color: #525956;
                }
                &:not(:last-child):after {
                    content: "/";
                    margin-left: 5px;
                    margin-right: 10px;
                }
            }
        }
    }
    

</style>


// WEBPACK FOOTER //
// src/components/widge/Breadcrumb.vue